import request from '@/utils/request'

export function getAppVersionList() {
  return request({
    url: '/other/getAppVersionList',
    method: 'get',
    params: { hideLoad: 10 }
  })
}

